module.exports = __webpack_public_path__ + "static/media/HearoLogo.83ad7bf7.png";